/**
 * Document-class lock for ADR-020 subpages + status surfaces.
 * Spine CSS keys off `html.subpage` / `body.subpage`. Soft-nav between
 * subpages must not drop the class for a paint frame (useEffect cleanup →
 * FOUC: fixed header + backdrop blur ghosts the hero headline).
 */
let locks = 0;

export function acquireSubpageDocument() {
  locks += 1;
  document.documentElement.classList.add("subpage");
  document.body.classList.add("subpage");
}

export function releaseSubpageDocument() {
  locks = Math.max(0, locks - 1);
  if (locks > 0) return;
  document.documentElement.classList.remove("subpage");
  document.body.classList.remove("subpage");
}
